import { isMobile } from "react-device-detect";
import { Button } from "reactstrap";

import { SubtleBadge } from "@/components/Common/SubtleBadge";
import { Badge } from "@/components/Common/Badge";
import {
  AmountColumn,
  DateActionColumn,
  DateColumn,
  LinkWithAvatarColumn,
  ReferenceNoColumn,
  TextColumn
} from "@/components/Common/GridColumns";
import StaticDropDownActions from "@/components/Common/StaticDropDownActions";

export const getOrderRequestColumns = (handleActions) => {
  const desktopColumns = [
    {
      id: "files",
      header: () => <div className="text-center"><i className="ri-attachment-2" /></div>,
      size: 16,
      minSize: 16,
      maxSize: 16,
      enableSorting: false,
      enableColumnFilter: false,
      meta: { thStyle: { padding: "10px 2px 10px 12px", textAlign: "center" } },
      cell: ({ row }) => {
        const hasFiles = row?.original?.files?.length > 0;
        return (
          <div
            className="text-center"
            style={{ cursor: hasFiles ? "pointer" : "default" }}
            onClick={(e) => {
              e.stopPropagation();
              if (hasFiles) row.toggleExpanded();
            }}>
            {hasFiles ? <i className="ri-attachment-2 text-success h5 mb-0"></i> : ""}
          </div>
        );
      },
    },
    {
      header: "Order No.",
      accessorKey: "referenceNo",
      enableColumnFilter: false,
      size: 150,
      minSize: 150,
      maxSize: 150,
      cell: ({ row }) => {
        const transaction = row.original;
        return (
          <>
            <ReferenceNoColumn
              text={transaction.referenceNo}
              onClick={() => handleActions(transaction.actions.edit || transaction.actions.save ? "update" : "viewDetails", transaction)}
            />
            <SubtleBadge color={transaction.orderSourceColor} value={transaction.orderSourceName} />
          </>
        );
      },
    },
    {
      header: "Patient",
      accessorKey: "patientName",
      enableSorting: true,
      cell: ({ row }) => {
        const transaction = row.original;
        return (
          <LinkWithAvatarColumn
            onClick={() => handleActions(transaction.actions.edit || transaction.actions.save ? "update" : "viewDetails", transaction)}
            name={row.original.patientName}
            subName={row.original.patientCode}
            avatar={null}
          />
        );
      },
    },
    {
      header: "Doctor",
      accessorKey: "doctorName",
      enableSorting: true,
      cell: ({ row }) => {
        const transaction = row.original;
        return (
          <LinkWithAvatarColumn
            onClick={() => handleActions(transaction.actions.edit || transaction.actions.save ? "update" : "viewDetails", transaction)}
            name={row.original.doctorName}
            subName={row.original.doctorCode}
            avatar={null}
          />
        );
      },
    },
    // {
    //   header: "Date Prescribed",
    //   accessorKey: "prescribedDate",
    //   enableSorting: true,
    //   size: 90,
    //   minSize: 90,
    //   maxSize: 90,
    //   cell: ({ row }) => {
    //     const transaction = row.original;
    //     return (
    //       <DateColumn
    //         onClick={() => handleActions(transaction.actions.edit || transaction.actions.save ? "update" : "viewDetails", transaction)}
    //         value={row.original?.prescribedDate}
    //       />
    //     );
    //   },
    // },
    {
      header: "Order Date",
      accessorKey: "orderDate",
      enableSorting: true,
      size: 90,
      minSize: 90,
      maxSize: 90,
      cell: ({ row }) => {
        const transaction = row.original;
        return (
          <DateColumn
            onClick={() => handleActions(transaction.actions.edit || transaction.actions.save ? "update" : "viewDetails", transaction)}
            value={row.original?.orderDate}
          />
        );
      },
    },
    {
      header: "Delivery Date",
      accessorKey: "deliveryDate",
      enableSorting: true,
      size: 90,
      minSize: 90,
      maxSize: 90,
      cell: ({ row }) => {
        const transaction = row.original;
        return (
          <DateColumn
            onClick={() => handleActions(transaction.actions.edit || transaction.actions.save ? "update" : "viewDetails", transaction)}
            value={row.original?.deliveryDate}
          />
        );
      },
    },
    {
      header: "Date Received",
      accessorKey: "dateReceived",
      enableSorting: true,
      size: 90,
      minSize: 90,
      maxSize: 90,
      cell: ({ row }) => {
        const transaction = row.original;
        return (
          <DateColumn
            onClick={() => handleActions(transaction.actions.edit || transaction.actions.save ? "update" : "viewDetails", transaction)}
            value={row.original?.dateReceived}
          />
        );
      },
    },
    {
      header: "Total",
      accessorKey: "totalPrice",
      enableSorting: true,
      size: 80,
      minSize: 80,
      maxSize: 80,
      cell: ({ row }) => {
        const transaction = row.original;
        return (
          <AmountColumn
            amount={row.original.totalPrice}
            onClick={() => handleActions(row.original.actions?.edit || row.original.actions?.save ? "update" : "viewDetails", row.original)}
          />
        );
      },
    },
    {
      header: "Status",
      accessorKey: "status",
      enableColumnFilter: false,
      size: 100,
      minSize: 100,
      maxSize: 100,
      cell: ({ row }) => {
        const transaction = row.original;
        return (
          <Badge
            color={transaction.statusColor}
            value={transaction.statusName}
            onClick={() => handleActions(transaction.actions.edit || transaction.actions.save ? "update" : "viewDetails", transaction)}
          />
        );
      },
    },
    {
      header: "Last Update",
      accessorKey: "modifiedDate",
      enableColumnFilter: false,
      size: 150,
      minSize: 150,
      maxSize: 150,
      cell: ({ row }) => {
        const transaction = row.original;
        return (
          <DateActionColumn
            actionDate={transaction.modifiedDate}
            actionBy={transaction.modifiedByName}
            onClick={() => handleActions(transaction.actions.edit || transaction.actions.save ? "update" : "viewDetails", transaction)}
          />
        );
      },
    },

    {
      header: "Actions",
      size: 50,
      minSize: 50,
      maxSize: 50,
      cell: ({ row }) => {
        const data = row.original;
        return (
          <StaticDropDownActions
            data={data}
            handleActions={handleActions}
            viewDetails={true}
            isShowEdit={data?.actions?.edit}
            isShowDelete={data?.actions?.delete}
            customItems={[
              ...(data?.actions?.print
                ? [
                  {
                    action: "print",
                    label: "Print",
                    icon: "ri-printer-fill",
                  },
                ]
                : []),
            ]}
          />
        );
      },
    },
  ];

  const mobileColumns = [
    {
      accessorKey: "referenceNo",
      enableColumnFilter: false,
      enableSorting: true,
      getInitialSortDirection: () => "asc",
      cell: ({ row }) => {
        const data = row.original;
        return (
          <div>
            <div className="d-flex align-items-center justify-content-between">
              {" "}
              <ReferenceNoColumn
                text={data.referenceNo}
                onClick={() => handleActions(data.actions.edit || data.actions.save ? "update" : "viewDetails", data)}
              />{" "}
              <StaticDropDownActions
                data={data}
                handleActions={handleActions}
                viewDetails={true}
                isShowEdit={data?.actions?.edit}
                isShowDelete={data?.actions?.delete}
                customItems={[
                  ...(data?.actions?.print
                    ? [
                      {
                        action: "print",
                        label: "Print",
                        icon: "ri-printer-fill",
                      },
                    ]
                    : []),
                ]}
              />{" "}
            </div>
            <div onClick={() => handleActions(data.actions.edit || data.actions.save ? "update" : "viewDetails", data)}>
              <div className="d-flex align-items-center w-100 justify-content-end">
                <small>
                  {" "}
                  <Badge color={data.statusColor} value={data.statusName} />
                </small>
              </div>
            </div>
          </div>
        );
      },
    },
  ];

  return isMobile ? mobileColumns : desktopColumns;
};

export const getItemsColumn = (handleActions) => {
  const desktopColumns = [
    {
      header: "Product",
      accessorKey: "productName",
      enableSorting: true,
      size: 150,
      minSize: 150,
      cell: ({ row }) => {
        return <TextColumn text={row.original.productName || "-"} onClick={() => handleActions("update", row.original)} />;
      },
    },
    {
      header: "PAP Scheme",
      accessorKey: "papSchemeName",
      enableSorting: true,
      size: 100,
      maxSize: 100,
      cell: ({ row }) => {
        return <TextColumn text={row.original.papSchemeName || "-"} onClick={() => handleActions("update", row.original)} />;
      },
    },
    {
      header: "Quantity",
      accessorKey: "commercialQuantity",
      enableSorting: true,
      size: 50,
      minSize: 50,
      maxSize: 50,
      cell: ({ row }) => {
        return (
          <>
            <div className={"d-flex align-items-center cursor-pointer"} onClick={() => handleActions("update", row.original)}>
              <div className="flex-grow-1">
                <span className="text-muted">PAP: </span> <span>{row.original.papQuantity}</span>
                <p className="mb-0">
                  <span className="text-muted">Commercial: </span> <span>{row.original.commercialQuantity}</span>
                </p>
              </div>
            </div>
          </>
        );
      },
    },
    {
      header: "Price",
      accessorKey: "price",
      enableSorting: true,
      size: 80,
      minSize: 80,
      maxSize: 80,
      cell: ({ row }) => {
        return <AmountColumn amount={row.original.price} onClick={() => handleActions("update", row.original)} />;
      },
    },
    {
      header: "Sub Total",
      accessorKey: "subTotal",
      enableSorting: true,
      size: 80,
      minSize: 80,
      maxSize: 80,
      cell: ({ row }) => {
        return <AmountColumn amount={row.original.subTotal} onClick={() => handleActions("update", row.original)} />;
      },
    },

    {
      header: "Actions",
      enableSorting: false,
      size: 80,
      minSize: 80,
      maxSize: 80,
      cell: ({ row }) => {
        return (
          <div className="d-flex gap-2 justify-content-center">
            <Button type="button" className="btn btn-sm btn-soft-info" onClick={() => handleActions("update", row.original)}>
              <i className="ri-pencil-fill" />
            </Button>

            <Button type="button" className="btn btn-sm btn-soft-danger" onClick={() => handleActions("delete", row.original)}>
              <i className="ri-delete-bin-fill" />
            </Button>
          </div>
        );
      },
    },
  ];

  const mobileColumns = [
    {
      header: "Item",
      accessorKey: "productName",
      cell: ({ row }) => {
        const item = row.original;
        return (
          <div onClick={() => handleActions("update", item)}>
            <strong>{item.productName}</strong>

            <div className="text-muted">
              Commercial: {item.commercialQuantity} · PAP: {item.papQuantity}
            </div>

            <div className="text-muted">{item.treatmentStatusName || "-"}</div>

            <div className="text-muted">Price: {item.price}</div>
          </div>
        );
      },
    },
  ];

  return isMobile ? mobileColumns : desktopColumns;
};

export const getItemsViewColumn = () => {
  const desktopColumns = [
    {
      header: "Product",
      accessorKey: "productName",
      enableSorting: true,
      size: 150,
      minSize: 150,
      cell: ({ row }) => {
        return <TextColumn text={row.original.productName || "-"} />;
      },
    },
    {
      header: "PAP Scheme",
      accessorKey: "papSchemeName",
      enableSorting: true,
      size: 100,
      maxSize: 100,
      cell: ({ row }) => {
        return <TextColumn text={row.original.papSchemeName || "-"} />;
      },
    },
    {
      header: "Quantity",
      accessorKey: "commercialQuantity",
      enableSorting: true,
      size: 50,
      minSize: 50,
      maxSize: 50,
      cell: ({ row }) => {
        return (
          <>
            <div className={"d-flex align-items-center"} >
              <div className="flex-grow-1">
                <span className="text-muted">PAP: </span> <span>{row.original.papQuantity}</span>
                <p className="mb-0">
                  <span className="text-muted">Commercial: </span> <span>{row.original.commercialQuantity}</span>
                </p>
              </div>
            </div>
          </>
        );
      },
    },
    {
      header: "Price",
      accessorKey: "price",
      enableSorting: true,
      size: 80,
      minSize: 80,
      maxSize: 80,
      cell: ({ row }) => {
        return <AmountColumn amount={row.original.price} />;
      },
    },

    {
      header: "Sub Total",
      accessorKey: "subTotal",
      enableSorting: true,
      size: 80,
      minSize: 80,
      maxSize: 80,
      cell: ({ row }) => {
        return <AmountColumn amount={row.original.subTotal} />;
      },
    },
  ];

  const mobileColumns = [
    {
      header: "Item",
      accessorKey: "productName",
      cell: ({ row }) => {
        const item = row.original;
        return (
          <div onClick={() => handleActions("update", item)}>
            <strong>{item.productName}</strong>

            <div className="text-muted">
              Commercial: {item.commercialQuantity} · PAP: {item.papQuantity}
            </div>

            <div className="text-muted">{item.treatmentStatusName || "-"}</div>

            <div className="text-muted">Price: {item.price}</div>
          </div>
        );
      },
    },
  ];

  return isMobile ? mobileColumns : desktopColumns;
};
